export default __webpack_public_path__ + "static/intro_mobile-64589f5a317845736c1e1e39fea3d534.mp4";